import tw, { styled } from "twin.macro";
import CloseIcon from "../../_images/close.svg";
import CenturionCard from "../../_images/CenturionCard.png";
import PlatinumCard from "../../_images/PlatinumCard.png";
import GoldCard from "../../_images/GoldCard.png";

export const CardImage = styled.div(({ cardType }) => {
  const cardBg = `background: url("${
    cardType === "gold"
      ? GoldCard
      : cardType === "platinum"
      ? PlatinumCard
      : CenturionCard
  }") center center / contain no-repeat;`;

  return [
    `width: 44px; height: 24px; display: inline-block; margin-right: 8px;`,
    cardBg,
  ];
});

export const ModalMask = styled.div(() => [
  `background-color: rgba(0,0,0,0.5);`,
  tw`fixed w-full h-full z-50 top-0 left-0`,
]);

export const ModalContainer = styled.div((modal) => {
  const isTsAndCs = modal.type === "tsandcs";
  const isSpecialOffer = modal.type === "specialoffer";

  let styles = `
    transition: 0.5s ease;
    background-color: white;
  `;

  if (isTsAndCs) {
    styles += `
      height: 90%;
      background-color: white;
      width: calc(90% - 32px);

      @media screen and (min-width: 768px) {
        height: 75%;
        max-width: 616px;
      }

      @media screen and (min-width: 1024px) {
        height: 75%;
        max-width: 816px;
      }
    `;
  } else if (isSpecialOffer) {
    styles += `
      background-color: white;

      @media screen and (min-width: 768px) {
        width: 456px;
      }
    `;
  } else {
    styles += `
      max-height: 90%;
      background-color: #F7F8F9;
      width: calc(90% - 32px);
    `;
  }

  return [
    styles,
    tw`shadow-xl mx-auto fixed top-1/2 left-1/2 rounded-lg transform -translate-x-1/2 -translate-y-1/2 flex flex-col z-50`,
  ];
});

export const ErrorMsg = styled.div(() => [
  ``,
  tw`flex justify-center text-white`,
]);

export const Card = styled.div(() => [
  `transition: transform 0.1s ease-in-out; &:hover{transform: scale(1.05); z-index: 99;};`,
  tw`flex flex-col text-copy bg-white p-4 pt-3 rounded border border-[#ECEDEE] shadow-sm`,
]);

export const CardWrapper = styled.div(() => [
  `> div {width: 100%;}`,
  `> div > div { margin-bottom: 1rem; }`,
  tw`w-full flex flex-row flex-wrap overflow-scroll z-[-1] justify-center px-[16px] md:px-[56px] pt-[24px]`,
]);

export const TsAndCsWrapper = styled.div(() => [
  `padding: 16px 24px; margin-bottom: 5rem;`,
  tw`text-gray-700 w-full flex flex-row flex-wrap overflow-scroll z-[-1]`,
]);

export const SpecialOfferWrapper = styled.div(() => [
  `padding-top: 24px;`,
  tw`text-gray-700 w-full flex flex-row flex-wrap overflow-scroll justify-center pb-4 px-[20px]`,
]);

export const TabButtons = styled.div(() => [
  `padding: 16px 24px`,
  tw`text-gray-700 w-full flex flex-row justify-center gap-x-1.5`,
]);
export const TabButton = styled.button(() => [
  ``,
  tw`text-red-700 px-4 py-[4px] rounded flex`,
]);

export const CardBody = styled.div(() => [
  `
  @media (max-width: 768px) { 
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    justify-items: center
  }
  @media (min-width: 768px) { 
    position: relative;
    grid-template-columns: 1fr 195px;
    gap: 1rem;
  }
  `,
  tw`grid`, // Adjust for small screens
]);
export const Left = styled.div(() => [
  ``,
  tw`justify-center md:justify-start text-center md:text-left items-center`, // Adjust for small screens
]);

export const CardFooter = styled.div(() => [``, tw`mt-4 text-center`]);

export const Title = styled.h2(() => [
  `letter-spacing:-0.41px;`,
  tw`text-base pb-3`,
]);

export const Address = styled.div(() => [
  ``,
  tw`text-sm leading-5 mb-4 font-thin`,
]);

export const Detail = styled.div(() => [
  `a{color:#006FCF}+ div {margin-top:0.6875rem;}`,
  `
    a {
      &:focus {
        outline: 1px dashed currentColor;
        outline-offset: 3px;
      }
    }
  `,
  tw`text-sm leading-snug flex justify-center md:justify-start`,
]);

export const MapLink = styled.div(() => [
  `a{color:#006FCF}+ div {margin-top:0.6875rem;}`,
  `
    a {
      &:focus {
        outline: 1px dashed currentColor;
        outline-offset: 3px;
      }
    }
  `,
  `:hover { 
    background-color: rgba(236, 237, 238, 0.7);
  }
  `,
  ` 
    padding: 0.5rem 0;
  `,
  tw`text-sm leading-snug flex w-full justify-center rounded cursor-pointer`,
]);

export const MapAndBooking = styled.div(() => [
  ``,
  tw`flex flex-col justify-center items-center`,
]);

export const RestaurantBanner = styled.div(() => [
  `
    font-size: 20px;
    line-height: 110%;
    font-weight: 300;
    padding-top: 32px;
    z-index: -1;
  `,
  tw`text-gray-700 text-center relative w-full block rounded-t-lg flex justify-center items-center`,
]);

export const TsAndCsBanner = styled.div(() => [
  tw`text-gray-700 py-5 text-center relative w-full block rounded-t-lg font-light text-xl`,
]);

export const TsAndCsContent = styled.div(() => [
  `> ul {list-style: disc; padding-left: 1rem; padding-right: 1rem;}`,
  `> ul > li {margin-bottom: 8px;}`,
  `> ol {list-style: decimal;}`,
  `> ol > li {padding-left: 1rem}`,
  `ol > li > ol {list-style: upper-roman; padding: 1rem 0 0rem 1rem;}`,
  `ol > li > ol > li {padding-bottom: 1rem; padding-left: 1rem;}`,
  `> a {text-decoration: underline;}`,
  `a {text-decoration: underline;}`,
  `> .margin-top {margin-top: 8px;}`,
  `> .margin-bottom {margin-bottom: 8px;}`,
  `> .margin-y {margin-bottom: 8px; margin-top: 8px;}`,
  `> h2 {font-weight: 500}`,
  `> h3 {font-weight: 500}`,
  `> h4 {font-weight: 500}`,
  `p b {font-weight: 500}`,
  `p strong {font-weight: 500}`,
  `p + p {margin-top: 1em;}`,
  `p + h3 {margin-top: 1em;}`,
  `p + ul {margin-top: 1em;}`,
  `h2 + p {margin-top: 1em;}`,
  `h2 + ul {margin-top: 1em;}`,
  `h3 + ul {margin-top: 1em;}`,
  `> table {
    width: 100%;
    border-collapse: collapse;
  }`,
  `> thead {
    display: table-header-group; /* Ensure headers appear correctly */
  }`,
  `> th, td {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd;
  }`,
  `
  @media screen and (max-width: 600px) {
    table {
      border: 0;
    }

    thead {
      display: none; /* Hide table header */
    }

    tbody, tr, td {
      display: block; /* Make rows and cells block-level */
      width: 100%; /* Full width for cells */
    }

    tr {
      margin-bottom: 1em; /* Add space between stacked rows */
    }

    td {
        padding-top: 24px;
        position: relative;
    }

    td::before {
      content: attr(title) ":";
      position: absolute;
      top: 2px;
      width: 94%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
    }
  }
  `,
  tw`md:px-10 mt-4 w-full block font-light text-sm`,
]);

export const CloseBanner = styled.div((modal) => {
  const isSpecialOffer = modal.type === "specialoffer";

  let specialOfferStyles = tw`h-20 pt-2 w-full bottom-0 flex justify-center`;
  let styles = tw`h-20 bg-white text-white pt-2 shadow-top-only rounded-b-lg  text-center fixed w-full block bottom-0 flex justify-center`;
  return [
    ``,
    isSpecialOffer ? specialOfferStyles : styles,
  ];
});

export const Instruction = styled.div(({ marginBottom, weight }) => [
  `font-weight:${weight ? weight : 400};margin-bottom:${
    marginBottom ? marginBottom : 0
  }px;`,
  tw` flex`,
]);

export const DetailSVG = styled.svg(() => [
  `min-width:16px;`,
  tw`flex self-center mr-2`,
]);

export const Button = styled.a(() => [
  ``,
  `
  :focus {
    outline: 1px dashed #333;
    outline-offset: 3px;
  }
  `,
  `
  :hover {
    background-color: rgba(200, 201, 199, 0.75);
  }
  `,
  tw`h-12 block text-gray-700 text-center leading-[3rem] bg-[#ECEDEE] rounded whitespace-nowrap overflow-hidden overflow-ellipsis pl-3 pr-3 w-full`,
]);

export const ViewMap = styled.a(() => [``, tw`mr-2`]);

export const CloseButton = styled.button(() => [
  `
  :focus {
    outline: 1px dashed #333;
    outline-offset: 3px;
  }
  `,
  tw`h-12 block mt-2 text-gray-700 text-center leading-[3rem] bg-[#ECEDEE] rounded whitespace-nowrap overflow-hidden overflow-ellipsis pl-3 pr-3 w-52 cursor-pointer`,
]);

export const ButtonDisabled = styled.span(() => [
  `background-color:rgba(0,0,0,0.5);`,
  tw`h-12 block mt-2 text-white text-center leading-10 rounded whitespace-nowrap overflow-hidden overflow-ellipsis pl-3 pr-3 w-full`,
]);

export const Cross = styled.button(() => [
  `
  display: block;
  background-image: url(${CloseIcon});
  background-size: 16px 16px;
  width: 16px;
  height: 16px;
  `,
  `
  :focus {
    outline: 1px dashed #fff;
    outline-offset: 3px;
  }
  `,
  tw`absolute right-[1rem] top-[1rem] cursor-pointer`,
]);
